import { useTranslation } from '@crehana/i18n';
import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';
import { Col, colors, Container, Row } from '@crehana/ui';

import {
  CardsContainer,
  StyledCard,
  StyledH4,
  StyledImage,
  StyledSubtitle,
} from './Product.styles';

import { ProductTabType } from './types';

const ProductTab: React.FC<ProductTabType> = ({
  title,
  description,
  cards,
  image,
}) => {
  const { t, countryCode } = useTranslation();
  const bottomImage = countryCode === 'br' ? image.pt : image.es;
  return (
    <Container full className="overflow-hidden bg-gray-lighter">
      <Row>
        <Col className="relative pb-160 sm:pb-0">
          <article className="text-center px-32 pb-24 md:pb-0 pt-32 md:pt-40">
            <StyledH4 className="font-h4 text-primary-main mb-16 sm:text-32 sm:leading-40">
              {t(title)}
            </StyledH4>
            <StyledSubtitle className="font-body2 mb-24 mx-auto md:text-18 md:leading-28 md:mb-40">
              {t(description)}
            </StyledSubtitle>
            <CardsContainer className="sm:flex flex-row flex-wrap m-auto justify-center">
              {cards.map(({ description, icon: Icon }, i) => (
                <StyledCard
                  index={i}
                  className="text-left  bg-white rounded-10  flex flex-col justify-start mx-auto mb-24 px-20 py-16 flex-shrink-0 md:mx-0 md:mr-12"
                  key={`product-card-${i}`}
                >
                  <Icon size={24} color={colors.primaryMain} />
                  <p className="mt-8 text-14 leading-18 font-bold font-nun">
                    {t(description)}
                  </p>
                </StyledCard>
              ))}
            </CardsContainer>
          </article>
          <StyledImage className="absolute sm:relative z-3 m-auto w-full">
            <CustomNextImage
              src={bottomImage}
              blurDataURL={createImgixPlaceholder(bottomImage)}
              layout="fill"
              alt="Hero background"
              objectFit="contain"
              objectPosition="bottom center"
              placeholder="blur"
            />
          </StyledImage>
        </Col>
      </Row>
    </Container>
  );
};

export default ProductTab;
